import { cn } from './types';

interface EmptyStateProps {
  message?: string;
  className?: string;
}

export function EmptyState({
  message = 'No data available',
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('ui-empty', className)} role="status">
      <p>{message}</p>
    </div>
  );
}
